import * as React from 'react'
import { Avatar, Card, Col, Row } from 'antd'

import badgeIcon from '../../content/ic_badge_notifica.png'
import "./TileCard.less"

interface TileCardProps extends React.HTMLAttributes<HTMLDivElement> {
    onClick: () => void
    icon: React.ReactNode
    highlighted: boolean
}

export const TileCard: React.FC<TileCardProps> = ({
    onClick,
    icon,
    highlighted,
    children,
    tabIndex = 0,
    role = "button",
    onKeyDown,
    ...rest
}) => {
    // Gestione attivazione via tastiera se non fornita dal genitore
    const handleKeyDown = (e: React.KeyboardEvent<HTMLDivElement>) => {
        if (onKeyDown) onKeyDown(e)
        if (!e.defaultPrevented && (e.key === 'Enter' || e.key === ' ')) {
            e.preventDefault()
            onClick()
        }
    }

    return (
        <div
            onClick={onClick}
            tabIndex={tabIndex}
            role={role}
            onKeyDown={handleKeyDown}
            {...rest}
        >
            <Card>
                {highlighted ? <img src={badgeIcon} className="tile-card-badge" alt="" /> : null}
                <Row justify="center" align="middle" className="tile-card-row">
                    <Col xl={10} lg={6} sm={4} xs={12}>
                        <Avatar src={icon} size={40} className="tile-card-avatar" alt=""  />
                    </Col>
                    <Col xl={14} lg={18} sm={20} xs={12}>
                        <span className="Regular16Grey800">{children}</span>
                    </Col>
                </Row>
            </Card>
        </div>
    )
}